// automatically generated by the FlatBuffers compiler, do not modify

export enum EscalatorTraffic {
  P = 0,
  CarCall = 1,
  RearCarCall = 2,
  HallCall = 3,
  UpHallCall = 4,
  UpRearHallCall = 5,
  DownHallCall = 6,
  DownRearHallCall = 7
}
